import { useState } from "react";
import "./tags.css";

export default function TagsInput({
  value = [],
  onChange,
  placeholder = "Type and press Enter",
}) {
  const [input, setInput] = useState("");

  const addTag = (tag) => {
    const newTag = tag.trim();

    if (!newTag) return;

    if (!value.includes(newTag)) {
      onChange([...value, newTag]);
    }
  };

  const removeTag = (index) => {
    onChange(
      value.filter((_, i) => i !== index)
    );
  };

  const handleKeyDown = (e) => {
    if (
      e.key === "Enter" ||
      e.key === "," ||
      e.key === "Tab"
    ) {
      e.preventDefault();

      addTag(input);

      setInput("");
    }

    if (
      e.key === "Backspace" &&
      !input &&
      value.length
    ) {
      removeTag(value.length - 1);
    }
  };

  const handlePaste = (e) => {
    const pastedText =
      e.clipboardData.getData("text");

    const tags = pastedText
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);

    if (tags.length) {
      e.preventDefault();

      const uniqueTags = [
        ...new Set([
          ...value,
          ...tags,
        ]),
      ];

      onChange(uniqueTags);
    }
  };

  return (
    <div className="tags-input">

      {value.map((tag, index) => (
        <div
          key={index}
          className="tag"
        >
          {tag}

          <span
            onClick={() =>
              removeTag(index)
            }
          >
            ×
          </span>
        </div>
      ))}

      <input
        value={input}
        className="form-control"
        placeholder={placeholder}
        onChange={(e) =>
          setInput(e.target.value)
        }
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
      />

    </div>
  );
}